import { api } from '@/api';
import { AppTablesTypeMap } from '@polybank/shared';

/**
 * From client side it is not possible to get all the documents from a table.
 * There are workarounds to do it, but they are not efficient.
 * From backend side it is instead possible
 * @param tableName
 * @returns
 */
async function listAllRows<K extends keyof AppTablesTypeMap>(
  tableName: K,
  sortBy?: string,
  sortOrder?: 'asc' | 'desc'
): Promise<AppTablesTypeMap[K][]> {
  const result = await api.v1.bulk({ resource: tableName }).get({
    query: {
      sortBy,
      sortOrder,
    },
  });
  if (result.response.ok) {
    return result.data as AppTablesTypeMap[K][];
  }
  return [];
}

const transactionsService = {
  listAllRows,
};

export default transactionsService;
